/* eslint-disable quotes */
/* eslint-disable space-before-function-paren */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "element-ui/lib/theme-chalk/index.css";
import "./assets/css/index.css";
import 'babel-polyfill'
import promise from 'es6-promise'
import Vue from "vue";

import store from "../src/config/store";
import axios from "../src/config/axios";
import VueAxios from "vue-axios";

import VueMeta from 'vue-meta'
import ElementUI from "element-ui";

import App from "./App";
import router from "./router";

promise.polyfill();

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueAxios, axios);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  data: function () {
    return {
      GLOADING: false
    };
  },
  router,
  store,
  components: {
    App
  },
  template: "<App/>",
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js